import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../styles.css';


// colors[index]
const PlanCard = ({plan, activePlan, cardColor, isYearly, index, handleSubscription}) => {

    const isActiveSub = activePlan.plan === plan.name;
    const tooltip = (<Tooltip id="current-plan">Current plan</Tooltip>);

    const currentPlanIcon = (
        <OverlayTrigger placement="bottom" overlay={tooltip}>
            <AutoAwesomeIcon fontSize="small" style={{margin: "0px"}}/>
        </OverlayTrigger>
    );

    var planCanBeSubscribed = null;
    if (activePlan.plan === null || activePlan.plan === undefined){
        planCanBeSubscribed = true;
    } else {
        if (activePlan.plan === 'Free' && plan.name === 'Basic'){
            planCanBeSubscribed = true;
        } else {
            planCanBeSubscribed = false;
        }
    }
    const yearlyPrice = (Number(plan.price)*12*(1 - Number(plan.discount))).toFixed(0);
    const monthlyPrice = (Number(plan.price)).toFixed(1);
    const discountText = (Number(plan.discount) > 0 ? 
        <div className='disount'>{Number(plan.discount)*100}% off</div> : 
        null);

    const monthlyPriceText = (<p className='m-0'><span className='price'>${monthlyPrice}</span></p>);
    const yearlyPriceText = (<p className='m-0'><span className='price'>${yearlyPrice}</span></p>);
    const freePrice = (<p className='m-0'><span className='price'>${Number(plan.price)}</span></p>);
    const canBeUpgraded = activePlan.plan === 'Free' && !isActiveSub;
    const payment = isYearly ? yearlyPrice : monthlyPrice;

    return (
        <div key={index} className={`card-custom ${isActiveSub ? 'active' : ''}`}>

            <div className='card-custom-header' 
                style={{backgroundColor: cardColor}}>
            </div>

            <h2 className='card-custom-title'>
                {isActiveSub && currentPlanIcon}{plan.name} Plan
            </h2>                                        

            <div className='card-custom-content'>
                <div className='card-custom-body'>
                    <p className='m-0'>{plan.description}</p>
                </div>

                <div className='flex-row-center'>
                    {
                        Number(plan.price) == 0 ? freePrice : isYearly ? 
                            <>{yearlyPriceText}{discountText}</> : monthlyPriceText
                    }
                </div>

                <div className='flex-row-center'>
                <p style={{fontSize: 'small', marginBottom: '0.5rem'}}>{ plan.name === 'Free' ? 
                    `Free subscription for ${plan.duration} days` : 
                    isYearly ? 'Yearly subscription' : 'Monthly subscription'}</p>
                </div>

                <button className='btn-custom ligth' 
                    onClick={() => handleSubscription(plan, payment)}
                    style={{backgroundColor: cardColor}}
                    disabled={!planCanBeSubscribed}>
                        {canBeUpgraded ? `Upgrade to ${plan.name}` : isActiveSub ? 'Current' : 'Subscribe'}
                </button>
            </div>

        </div>
    );
};

export default PlanCard;
